import { Link } from "react-router-dom";
import { Crown, Sparkles, Zap, ArrowLeft } from "lucide-react";
import { useT } from "@/i18n";

/**
 * Full-page upgrade gate shown to Free users when they try to enter any
 * Interview Practice screen. Mirrors the chat upgrade modal style for
 * brand consistency.
 */
export default function InterviewUpgradeGate() {
  const { t } = useT();
  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-8" data-testid="interview-upgrade-gate">
      <div className="max-w-lg w-full bg-white border-2 border-zinc-900 rounded-2xl overflow-hidden shadow-xl">
        {/* Header */}
        <div className="bg-gradient-to-br from-orange-500 to-pink-500 text-white px-8 py-8 text-center">
          <div className="inline-flex w-16 h-16 items-center justify-center rounded-full bg-white/20 backdrop-blur-sm">
            <Crown className="w-9 h-9" />
          </div>
          <h1 className="mt-4 text-3xl font-black tracking-tight">{t("iv_gate_title")}</h1>
          <p className="mt-2 text-base text-white/95">{t("iv_gate_sub")}</p>
        </div>

        {/* Body */}
        <div className="px-8 py-6">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500 mb-3">
            {t("iv_gate_what_you_get")}
          </div>
          <ul className="space-y-2.5 text-sm">
            <li className="flex items-start gap-2"><Sparkles className="w-4 h-4 text-orange-500 mt-0.5 shrink-0" /> {t("iv_gate_b1")}</li>
            <li className="flex items-start gap-2"><Sparkles className="w-4 h-4 text-orange-500 mt-0.5 shrink-0" /> {t("iv_gate_b2")}</li>
            <li className="flex items-start gap-2"><Sparkles className="w-4 h-4 text-orange-500 mt-0.5 shrink-0" /> {t("iv_gate_b3")}</li>
            <li className="flex items-start gap-2"><Sparkles className="w-4 h-4 text-orange-500 mt-0.5 shrink-0" /> {t("iv_gate_b4")}</li>
          </ul>

          <Link
            to="/app/billing"
            className="mt-6 inline-flex w-full items-center justify-center gap-2 bg-zinc-900 hover:bg-zinc-800 text-white font-bold py-3.5 rounded-md"
            data-testid="iv-gate-cta"
          >
            <Zap className="w-4 h-4" /> {t("iv_gate_cta")}
          </Link>
          <Link
            to="/app"
            className="mt-3 inline-flex w-full items-center justify-center gap-1 text-sm text-zinc-500 hover:text-zinc-900 py-2"
            data-testid="iv-gate-back"
          >
            <ArrowLeft className="w-4 h-4" /> {t("iv_gate_back")}
          </Link>
        </div>
      </div>
    </div>
  );
}
